export const PatientTitles = [
    { "value": "mr", "label": "Mr" },
    { "value": "ms", "label": "Ms" },
    { "value": "mrs", "label": "Mrs" },
    { "value": "miss", "label": "Miss" },
    { "value": "mx", "label": "Mx" },
    { "value": "dr", "label": "Dr" },
    { "value": "prof", "label": "Prof" }
]